import { Grid, styled } from '@mui/material'
import React from 'react'

export const Card = styled(Grid)`
    border: 1px solid #000;
    border-radius: 15px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    background: #fff;
    // box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.12);
    box-shadow: 1px 1px rgba(16, 24, 40, 0.12) ;
`;